import { Box, Tooltip, Typography, IconButton } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import TooltipContent from './TooltipContent';
import { sxConfig } from './calendarStyle';
import dayjs from 'dayjs';
import colorFinder from '../../utils/colorFinder';
import useParam from '../../context/ParamContext';

const SimpleTaskEventContent = ({ eventInfo, resources, setShowSimpleTaskReportDialog }) => {
  const { params } = useParam();
  const extendedProps = eventInfo.event.extendedProps;
  const status = extendedProps.status?.color;
  const title = eventInfo.event.title;

  const color = colorFinder(status);
  const textColor = color.textColor || '#000';

  return (
    <Tooltip
      arrow
      placement="top"
      title={<TooltipContent eventInfo={eventInfo} />}
      slotProps={{
        tooltip: {
          sx: sxConfig.tooltip,
        },
        arrow: { sx: sxConfig.tooltipArrow },
      }}
    >
      <Box
        sx={{
          ...sxConfig.eventBox,
          backgroundColor: color.colorBgCode,
          borderLeft: `3px solid ${textColor}`,
          display: 'grid',
          gridTemplateColumns:
            params.SHOW_TASK_CALENDAR_SIMPLETASK_REPORT_ICON === 'Y'
              ? {
                  xs: 'minmax(0, 1fr) 80px',
                  md: 'minmax(0, 1fr) 50px',
                }
              : 'minmax(0, 1fr)',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {eventInfo?.view?.type === 'dayGridMonth' ? (
          <Box>
            <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
              {title}
            </Typography>
          </Box>
        ) : (
          <Box>
            <Box>
              <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                F: {title}
              </Typography>
            </Box>
            <Box>
              <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                P: {extendedProps.project?.projectName}
              </Typography>
            </Box>
            <Box>
              <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                K: {dayjs(extendedProps.startDate).format('YYYY-MM-DD HH:mm')}
              </Typography>
            </Box>
            <Box>
              <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                H: {dayjs(extendedProps.endDate).format('YYYY-MM-DD HH:mm')}
              </Typography>
            </Box>
            <Box>
              <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                F: {extendedProps.responsiblePerson?.nickName}
              </Typography>
            </Box>
          </Box>
        )}
        {params.SHOW_TASK_CALENDAR_SIMPLETASK_REPORT_ICON === 'Y' && (
          <Box sx={sxConfig.reportIconContainer}>
            <IconButton
              sx={sxConfig.reportIconButton}
              onClick={async (e) => {
                e.stopPropagation();
                setShowSimpleTaskReportDialog({
                  open: true,
                  data: {
                    projectId: extendedProps?.projectId,
                    ...(params.SHOW_EMPLOYEE_ATTENDANCE_SIMPLETASK_FIELD === 'Y' && {
                      simpleTaskId: extendedProps?.simpleTaskId,
                      simpleTaskName: extendedProps?.simpleTaskName,
                    }),
                  },
                });
              }}
            >
              <AccessTimeIcon sx={sxConfig.reportIcon} />
            </IconButton>
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default SimpleTaskEventContent;
